import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { SubtradeChannelDropdownComponent }         from '../../components/DomainData/SubtradeChannelDropdown.component';
import { PaymentTermDropdownComponent }         from '../../components/DomainData/PaymentTermDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-primarygroup-override-edit',
  templateUrl: './PrimaryGroupOverrideEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => PrimaryGroupOverrideEditComponent)}]
})
export class PrimaryGroupOverrideEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(SubtradeChannelDropdownComponent) public subtradeChannelDropdownComponent: SubtradeChannelDropdownComponent;
    @ViewChild(PaymentTermDropdownComponent) public paymentTermDropdownComponent: PaymentTermDropdownComponent;

    @Input() public record: ent.PrimaryGroupOverride;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
            'primaryGroup' : '',
            'salesOrg' : '',
            'subtradeChannel' : '',
            'paymentTerm' : '',
            'DSDBarcodeFlag' : '',
            'StoreStampFlag' : '',
            'ACNNumber' : '',
            'EDIInboundProfileID' : '',
            'DUNSNumber' : '',
            'EDIVendorNumber' : '',
            'EDIOutboundProfileID' : '',
            'DEXCommID' : '',
            'DEXVersion' : '',
            'DEXEmpty' : '',
            'PODSDNumberIndicator' : '',
            'Document' : '',
            'Payer' : '',
            'AuthorizedMaterialList' : '',
            // 'DrPepperAuthorizedMaterialList' : '',
            'LocCode' : '',
            'MinimumOrderQuantityFeeCode' : '',
            'ZNPartnerRequired' : '',
            'IEI_Eligibility' : '',
            'AccountingClerk' : '',
            'PaymentEligibility' : '',
            'PaymentOptions' : '',
            'MyCokePermissions' : '',
            'inactive' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    subtradeChannelChange(event: any){
        
        this.record.SubtradeChannelID = event;
    }

    paymentTermChange(event: any){
        
        this.record.PaymentTermID = event;
    }
}